import { SignatureRead } from 'src/common/external/bambi-api/bambiApi';
import { formatFullName } from 'src/common/util/formatFullName';

import { TripSummaryEventPersonName } from '../TripSummaryEventPersonName';
import { TripSummaryOccuredAt } from '../TripSummaryOccuredAt';
import { TripSummaryTitle } from '../TripSummaryTitle';

export default function TripSummarySignatureItemHeader({
  tripSignature,
}: {
  tripSignature: SignatureRead;
}) {
  return (
    <div className={`flex w-full flex-col gap-1  p-2 pr-12 text-left`}>
      <div className="flex w-full items-center justify-between gap-1">
        <TripSummaryTitle title="Signature" />

        <TripSummaryOccuredAt occuredAt={tripSignature.created_at} />
      </div>
      <div className="flex w-full flex-wrap items-center justify-between">
        <div>&nbsp;</div>
        <TripSummaryEventPersonName name={formatFullName(tripSignature)} />
      </div>
    </div>
  );
}
